<template>
    <v-container fluid style="width: 100vw">
        <v-row>
            <v-col class="ml-5">
                <h1>Tickets Z</h1>
            </v-col>
            <v-col class="mr-3 d-flex justify-end">
                <v-btn
                    rounded
                    color="primary"
                    v-if="currentUser.profile.configuration.document.write"
                    @click="newTicketZ"
                    data-cy="zTillReceipts-create"
                >
                    Ajouter <v-icon class="margin-left-small">$fa-plus</v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12" v-for="(item, index) in items" :key="index" class="py-1">
                <v-card class="default_card ma-0 pa-2" elevation="0">
                    <v-row no-gutters>
                        <v-col cols="10" class="font-weight-bold subtitle-1 d-flex align-center">
                            {{ getDate(item.date) }} - {{ item.period }}
                        </v-col>
                        <v-col cols="2" class="d-flex justify-end" v-if="enableDelete(item)">
                            <v-btn-trash @click="deleteZTill(item)" size="small" />
                        </v-col>
                        <v-col cols="4" class="d-flex justify-center">
                            {{ item.netAmount ? mathFix(item.netAmount) + " &#x20ac;" : "-" }}
                        </v-col>
                        <v-col cols="4" class="d-flex justify-center">
                            {{ item.vatAmount ? mathFix(item.vatAmount) + " &#x20ac;" : "-" }}
                        </v-col>
                        <v-col cols="4" class="font-weight-bold d-flex justify-center">
                            {{ item.grossAmount ? mathFix(item.grossAmount) + " &#x20ac;" : "-" }}
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
        <DocumentWizardDialog
            v-model:active="newZTillReceipt"
            :companyId="selectedCompany.id"
            :showFirstPrevious="false"
            :inGlobalStep="'zTillReceipt'"
            @created="onZTillReceiptCreated"
        />
    </v-container>
</template>

<script lang="ts">
import moment from "moment-timezone";
import { Apollo } from "@/decorators";
import { User } from "../../store/store";

import TICKETSZ from "../../graphql/TicketsZ.gql";
import DELETE_ZTILL from "../../graphql/DeleteZTill.gql";

import { mathFix } from "../../services/mathServices";

import DocumentWizardDialog from "../document/DocumentWizardDialog.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";

@Component({
    components: {
        DocumentWizardDialog,
    },
})
export class TicketZPageMobile extends Vue {
    headers: Array<any> = [
        { text: "Date", value: "date" },
        { text: "Periode", value: "period" },
        { text: "Montant HT", value: "netAmount" },
        { text: "Montant TVA", value: "vatAmount" },
        { text: "Montant TTC", value: "grossAmount" },
        { text: "Supprimer", value: "" },
    ];

    newZTillReceipt: boolean = false;

    get selectedCompany() {
        return this.$store.state.selected_company;
    }

    @Apollo({
        query: TICKETSZ,
        variables() {
            return {
                companyId: this.selectedCompany.id,
            };
        },
        skip() {
            return !this.selectedCompany.id;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data) {
                    this.items = data.zTillReceipts;
                }
            }
        },
    })
    items: Array<any> = [];

    mathFix(value) {
        return mathFix(value);
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    openTicketZ(item: any) {
        this.$router.push({
            name: "zTillReceipt",
            params: {
                companyId: this.selectedCompany.id,
                id: item.id,
            },
        });
    }

    newTicketZ(item: any) {
        this.newZTillReceipt = true;
    }

    getDate(date) {
        if (date) return moment(date).format("DD-MM-YYYY");
        return "";
    }

    enableDelete(zTillReceipt: any) {
        if (!zTillReceipt) return false;
        if (zTillReceipt.documents) {
            for (const doc of zTillReceipt.documents) {
                if (doc.vatDeclaration) return false;
            }
        }
        if (zTillReceipt.accoutingItem) {
            return false;
        }
        return true;
    }

    async deleteZTill(zTillReceipt: any) {
        // const documents = result.data.zTillReceipt.documents
        debugger;
        // console.log('documents', documents.map((doc) => doc.id))

        // .map((doc) => doc.id)

        await this.$apollo.mutate({
            mutation: DELETE_ZTILL,
            variables: {
                zTillId: zTillReceipt.id,
            },
        });
        const index = this.items.findIndex((x) => x.id === zTillReceipt.id);
        this.items.splice(index, 1);
    }

    onZTillReceiptCreated() {
        this.newZTillReceipt = false;
        if (this.$apollo.queries.items) {
            this.$apollo.queries.items.refetch();
        }
    }
}

export default toNative(TicketZPageMobile);
</script>
<style scoped>
.margin-left-small {
    margin-left: 8px;
}
</style>
